import { useEffect } from "react";
import { useAuthState } from "../../../../MainComponents/GlobalContext";
import { useForm } from "react-hook-form";
import { useReducer } from "react";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";

const AdminCopyInvitationLink = () => {
  const AuthState = useAuthState();

  const [dataReferrals, errorReferrals, loadingReferrals] = useAxios(
    process.env.REACT_APP_ADMIN_REFERRALS_CURRENT_GET_API,
    "GET",
    "GET"
  );

  async function copy() {
    try {
      await navigator.clipboard.writeText(
        `https://nash-academy.com/register?ref=${AuthState?.userData?.admin?.referral_code}`
      );
      toast.success("Copied to clipboard");
    } catch (err) {
      console.error("Failed to copy: ", err);
      toast.error("Failed to copy to clipboard");
    }
  }

  return (
    <section className="h-auto width flex flex-col items-center mt-6">
      <h4 className="text-3xl font-bold">Copy Invitation Link</h4>
      <div className="flex w-3/4 flex-col items-start  justify-center gap-6 rounded-3xl bg-blue-200 p-10 shadow-lg shadow-blue/50 my-6">
        <p className="text-2xl font-bold">
          Students Invited : {dataReferrals?.referred_students_count}
        </p>

        <p className="text-2xl font-bold">
          This Month: {dataReferrals?.this_month}
        </p>

        <button onClick={copy} className=" submit mt-6 w-full " type="submit">
          Copy Link
        </button>
      </div>
    </section>
  );
};

export default AdminCopyInvitationLink;
